import { Indicator, Toast } from "mint-ui";
import ap from "alipay";
/* 
    封装蚂蚁金服jssdk
*/
function jsBridgeReady() {
  return new Promise((resolve, reject) => {
    if (window.AlipayJSBridge) {
      resolve();
    } else {
      reject();
    }
  });
}

if (!ap.isAlipay) {
  ap.showLoading = ({ content = "加载中" } = {}) => {
    Indicator.open(content);
  };
  ap.hideLoading = () => {
    Indicator.close();
  };
  ap.showToast = ({ content }) => {
    Toast({
      message: content,
      position: "bottom"
    });
  };
}

function choosePhoto() {
  return new Promise((resolve, reject) => {
    AlipayJSBridge.call(
      "photo",
      {
        dataType: "dataURL",
        imageFormat: "jpg",
        quality: 50,
        multimediaConfig: {
          // 可选，仅当该项被配置时，图片被传输至 APMultimedia
          compress: 4, // 可选，默认为4。 0-低质量，1-中质量，2-高质量，3-不压缩，4-根据网络情况自动选择
          business: "multiMedia" // 可选，默认为“NebulaBiz”
        }
      },
      function(result) {
        if (result.error) {
          reject("cancel choose photo");
        } else {
          resolve(result.dataURL);
        }
      }
    );
  });
}

function alipay(tradeNo) {
  return new Promise((resolve, reject) => {
    AlipayJSBridge.call(
      "tradePay",
      {
        tradeNO: tradeNo
      },
      function(res) {
        //   ap.alert(JSON.stringify(result));
        const { resultCode } = res;
        //   ap.alert(resultCode);
        if (resultCode == 6001) {
          reject("支付取消");
        } else if (resultCode == 9000) {
          //支付成功
          resolve("支付成功");
        } else {
          reject("支付失败");
        }
      }
    );
  });
}

export { choosePhoto, alipay };
